import { n$2 } from '@/js/global/global'

const selectors = {
  wrapper: "[data-delivery-estimate]",
  date: "[data-delivery-estimate-date]"
};

// Adds N business days (Mon-Fri) to a date, skipping weekends
function addBusinessDays(date, businessDays) {
  const result = new Date(date);
  let added = 0;
  while (added < businessDays) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 0 && day !== 6) added++;
  }
  return result;
}

// Formats as "Fri, Aug 25" (3 letter weekday and month)
function formatDate(date) {
  const weekday = date.toLocaleDateString("en-US", { weekday: "short" });
  const month = date.toLocaleDateString("en-US", { month: "short" });
  return "".concat(weekday, ", ").concat(month, " ").concat(date.getDate());
}

function deliveryEstimate(container) {
  const wrapper = n$2(selectors.wrapper, container);
  if (!wrapper) return;
  const dateEl = n$2(selectors.date, wrapper);
  const businessDays = parseInt(wrapper.dataset.businessDays, 10) || 6;
  dateEl.textContent = formatDate(addBusinessDays(new Date(), businessDays));

  const update = variant => {
    wrapper.hidden = !(variant && variant.available);
  };
  wrapper.hidden = wrapper.dataset.available !== "true";

  return {
    update
  };
}

export { deliveryEstimate, addBusinessDays, formatDate }
